import { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

class OutsideClickHandler extends Component {
  handleClickOutside = () => {
    this.props.onClickOutside();
  };

  render() {
    return this.props.children;
  }
}

export default onClickOutside(OutsideClickHandler);
